import React from 'react';
import GroupForm from './GroupForm';

const NewGroup = () => {
  return <GroupForm mode="create" />;
};

export default NewGroup;
